import React from 'react';
import { FieldTitle } from 'react-admin';
import { Grid } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import ListPopover from '../ListPopover';

const useStyles = makeStyles({
  inputTitleContainer: {
    marginBottom: '-12px !important',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

const FieldTitleWithListPopover = props => {
  const {
    items,
    onSelectItem,
    source,
    label,
    displayingVariables,
    isRequired,
    ListPopoverProps
  } = props;
  const classes = useStyles(props);

  return (
    <Grid container className={classes.inputTitleContainer}>
      <FieldTitle label={label} isRequired={isRequired} />
      {displayingVariables && (
        <ListPopover
          onSelectItem={onSelectItem}
          items={items}
          source={source}
          {...ListPopoverProps}
        />
      )}
    </Grid>
  );
};

FieldTitleWithListPopover.defaultProps = {
  displayingVariables: true,
  onSelectItem: () => {}
};

FieldTitleWithListPopover.propTypes = {
  items: ListPopover.propTypes.items,
  onSelectItem: PropTypes.func,
  source: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  displayingVariables: PropTypes.bool,
  ListPopoverProps: PropTypes.object
};

export default FieldTitleWithListPopover;
